export default __webpack_public_path__ + "static/media/digitalWhiteBoard.b30bd90a.svg";